import { createContext, useContext, useState } from "react";
import { setCurrency, getCurrency } from "@/lib/api";

const Ctx = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [cur, setCurState] = useState(getCurrency());
  const setCur = (c) => { setCurrency(c); setCurState(c); };
  return (
    <Ctx.Provider value={{ cur, setCur }}>
      <div key={cur} style={{ display: "contents" }}>{children}</div>
    </Ctx.Provider>
  );
};

export const useCurrency = () => useContext(Ctx);
